module.exports = __webpack_public_path__ + "img/1518296007.4d3a4f04.jpg";